/**
 * Index - Export all Inside Sales Dashboard components
 */

// Componentes individuais
import CadastroMedicos from "./CadastroMedicos";
import ResumoVisitas from "./ResumoVisitas";
import RegistroOcorrencias from "./RegistroOcorrencias";
import DadosRelevantes from "./DadosRelevantes";
import VisitasContato from "./VisitasContato";
import BaseMedicosOrigem from "./BaseMedicosOrigem";
import GeograficoEspecialidades from "./GeograficoEspecialidades";
import ProjecaoMetas from "./ProjecaoMetas";

// Container principal
import InsideSalesDashboard from "./InsideSalesDashboard";

// Map para uso dinâmico por slug
const insideSalesDashboardMap = {
  "inside_sales_cadastro_medicos": CadastroMedicos,
  "inside_sales_resumo_visitas": ResumoVisitas,
  "inside_sales_ocorrencias": RegistroOcorrencias,
  "inside_sales_dados_relevantes": DadosRelevantes,
  "inside_sales_visitas_contato": VisitasContato,
  "inside_sales_base_origem": BaseMedicosOrigem,
  "inside_sales_geografico": GeograficoEspecialidades,
  "inside_sales_metas": ProjecaoMetas,
  "inside_sales_full": InsideSalesDashboard
};

export default insideSalesDashboardMap;

export {
  CadastroMedicos,
  ResumoVisitas,
  RegistroOcorrencias,
  DadosRelevantes,
  VisitasContato,
  BaseMedicosOrigem,
  GeograficoEspecialidades,
  ProjecaoMetas,
  InsideSalesDashboard
};
